import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import {
  onMounted,
  ref,
  getCurrentInstance,
  PropType,
  computed,
} from "vue";
import { DictItem } from "@/model";

//接收父组件值

export default /*@__PURE__*/_defineComponent({
  __name: 'followStatusCom',
  props: {
  status: {
    type: String,
    default: "",
  },
},
  setup(__props) {

const props = __props;

// 跟进状态 1待分配 2分配失败，3待跟进，4跟进超时，5持续跟进，6跟进成功，7跟进失败，8无需跟进
const STATUS_LIST: DictItem[] = [
  {
    name: "待分配",
    value: "1",
  },
  {
    name: "分配失败",
    value: "2",
  },
  {
    name: "待跟进",
    value: "3",
  },
  {
    name: "跟进超时",
    value: "4",
  },
  {
    name: "持续跟进",
    value: "5",
  },
  {
    name: "跟进成功",
    value: "6",
  },
  {
    name: "跟进失败",
    value: "7",
  },
  {
    name: "无需跟进",
    value: "8",
  },
];

// 展示的状态文本名称
const statusText = computed(() => {
  let statusName = "";
  STATUS_LIST.forEach((item) => {
    if (item.value === props.status) {
      statusName = item.name;
      return statusName;
    }
  });
  return statusName;
});

onMounted(() => {
  // console.log(" mounted");
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["follow-status", `follow-status-${__props.status}`])
  }, _toDisplayString(statusText.value), 3))
}
}

})